import React, { useRef, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import { Login_initialize, LoginSet, NormalLogin } from "../../stores/slices/Login";
import { UserInfoGet } from "../../stores/Information";

const Login = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const search = useLocation().search;

    const informationState = useSelector((state) => state.Information);
    const LoginState = useSelector((state) => state.Login);

    useEffect(() => {
        //ログイン済みならトップページへ
        if(informationState["organizer"]["user_login"] === true)
        {
            history.push(`/`);
            return;
        }

        //dispatch(Login_initialize());
    });

    //戻る
    const LinkClick = () => {
        history.push(`/`);
    };

    //会員登録ボタン
    const EntranceUserClick = () => {
        history.push(`/EntranceUser`);
    };

    //仕様変更によりYahooID連携機能廃止
    // //YahooID連携
    // const HandleSubmit = (e) => {
    //     e.preventDefault();

    //     //localStorageからEntranceUserからの遷移である情報を削除（登録が無い場合、登録の初期画面へ遷移させるため）
    //     localStorage.removeItem("EntranceUser");

    //     window.location.href = '/yahoojpLogin';
    // };

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(LoginSet([name, value]));
    };

    //通常ログイン
    const LoginSubmit = (e) => {
        e.preventDefault();

        //ログイン処理
        dispatch(NormalLogin(LoginState)).then((user_data) => {
            const result = user_data.payload.result;
            if(result === 'OK')
            {
                //ログイン処理
                const arg = {login_token: user_data.payload.organizer.login_token};
                //パラメータのログイントークンから幹事データを取得しログイン処理する
                dispatch(UserInfoGet(arg)).then((data) => {
                    if(data.payload.data.user_login)
                    {
                        console.log('ログイン完了');
                        dispatch(Login_initialize());
                        //ログイン処理完了済み
                        const query = new URLSearchParams(search);
                        const from = query.get("from");
                        if(from === "ApplicationForm")
                        {
                            //申込フォームからの遷移ならログイン後に申込フォームへ
                            const urlSearchParam = search.toString();
                            history.push(`/ApplicationForm${urlSearchParam}`);
                            return;
                        }
                        //トップページへ
                        history.push(`/`);
                    }
                });
            }
            else
            {
                //NGメッセージ表示
                alert(user_data.payload.message);
            }
        });
    };

    return (
        <React.Fragment>
            <Button size="small" variant="outlined" onClick={LinkClick}>
                戻る
            </Button>

            <Typography variant="h2" gutterBottom component="div" align="center">
                LOGIN
            </Typography>
            
            <Grid
                container
                //direction="column"
                justifyContent="center"
                //alignItems="center"
                sx={{ minHeight: "300px" }}
            >
                <form onSubmit={LoginSubmit} style={{padding: "1rem 1.3rem"}}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        // sx={{ border: 1, maxWidth: "50rem" }}
                        sx={{ border: 1, minWidth: "30rem", maxWidth: "50rem" }}
                    >
                        <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                            <TextField
                                required
                                sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                label="メールアドレス"
                                variant="outlined"
                                name="email_address"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 60 }}
                                value={LoginState.email_address}
                                onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                            />
                        </Grid>
                        <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                            <TextField
                                required
                                sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                                label="パスワード"
                                variant="outlined"
                                name="password"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 255 }}
                                value={LoginState.password}
                                onChange={(e) => onChange({ name: "password", value: e.target.value })}
                                type="password"
                            />
                        </Grid>
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            sx={{ width: "8rem" }}
                            type="submit"
                        >
                            ログイン
                        </Button>
                        <Link to="/PasswordSetting">{"パスワードをお忘れの方"}</Link>
                    </Grid>
                </form>
                {/* <form onSubmit={HandleSubmit} id="ApplicationForm" style={{padding: "1rem 0rem"}} >
                    {"Yahoo! JAPAN IDでログイン"}
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ border: 1, maxWidth: "50rem" }}
                    >
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ width: "20rem", bgcolor: "#ff0033", m: 2 }}
                            type="submit"
                        >
                            <img
                                src="/images/Logo/yahoo_japan_icon_w_256.png"
                                width="30px"
                                style={{
                                    marginLeft: "0",
                                    marginRight: "auto",
                                    display: "block",
                                }}
                            />{"　"}
                            Yahoo! JAPAN IDでログイン
                        </Button>
                        {"（Yahoo! JAPAN IDで登録していない場合、会員登録画面へ移動します）"}
                    </Grid>
                </form> */}
            </Grid>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                {"初めてのご利用の方はこちら"}
                <Button
                    variant="contained"
                    size="large"
                    color="info"
                    sx={{ width: "8rem" }}
                    onClick={EntranceUserClick}
                >
                    会員登録
                </Button>
            </Grid>
            
            {/* {"Webサービス by Yahoo! JAPAN （https://developer.yahoo.co.jp/sitemap/）"} */}
        </React.Fragment>
    );
};

export default Login;
